export default {
  setDepartments: (state, payload) => (state.departments = payload)
}
